import { createContext, useContext } from "react";
import { StepsContextType, StepsProviderProps } from "./types";

const StepsContext = createContext<StepsContextType | undefined>(undefined);

export const StepsProvider = ({ children, step }: StepsProviderProps) => (
  <StepsContext.Provider value={{ step }}>{children}</StepsContext.Provider>
);

export const useSteps = () => {
  const context = useContext(StepsContext);

  if (!context) {
    throw new Error("useSteps must be used within a StepsProvider");
  }

  return context;
};
